import { classNames } from 'primereact/utils';
import './InputBase.scss';

type GetInputBaseClassNameProps = {
	inline?: boolean;
	disabled?: boolean;
	slim?: boolean;
	focus?: boolean;
	variant?: 'default' | 'primary-outlined';
	minimal?: boolean;
	invalid?: boolean;
};

export const getInputBaseClassName = ({
	inline = false,
	disabled = false,
	slim = false,
	focus = false,
	variant = 'default',
	minimal = false,
	invalid = false,
}: GetInputBaseClassNameProps = {}) =>
	classNames('input-base', `input-base-variant-${variant}`, {
		'input-base-inline': inline,
		'input-base-slim': slim,
		'input-base-focus': focus,
		'input-base-minimal': minimal,
		'input-base-invalid': invalid,
		disabled,
	});
